import { LoadingState, SectionHeader } from '../../../shared/components/index.js';
import { useLeadsData } from '../hooks/useLeadsData.jsx';
import HtmlBlock from '../components/HtmlBlock.jsx';
import { buildQualityHtml, buildWarningsHtml } from '../utils/present-leads-html.js';

export default function LeadsCalidadPage() {
  const { loading, data } = useLeadsData();
  if (loading && !data) return <LoadingState />;
  return (
    <>
      <HtmlBlock html={buildWarningsHtml((data && data.warnings) || [])} />
      <section className="analytics-section">
        <SectionHeader
          title="Calidad de datos"
          note="Diagnóstico de cobertura y calidad entregado por el backend."
        />
        <HtmlBlock
          html={buildQualityHtml(data && data.dataQuality, data && data.stageDwell)}
          className="analytics-panel"
        />
      </section>
    </>
  );
}
